import IResult from "../../models/result/IResult";
import OnboardingProgressModel from "../../models/onboarding/api/OnboardingProgressModel";
import { sendGet, sendPost, sendPut, sendPutWithCustomHeaders } from "./generic";

export const generateOnboardingLink = async (applicationId: string): Promise<IResult<string>> => {
    const result = await sendPost<string>(`/Onboarding/application/${applicationId}/link`, {});

    if (result.resultType === "Ok" && typeof result.data === "string") {
        try {
            const parsed = JSON.parse(result.data);
            if (typeof parsed === "string") {
                result.data = parsed;
            }
        } catch (_) {
        }
    }

    return result;
};

export const getOnboardingProgress = async (baseUrl?: string): Promise<IResult<OnboardingProgressModel>> => {
    return await sendGet<OnboardingProgressModel>("/Onboarding/progress", baseUrl);
};

export const getOnboardingProgressForApplication = async (applicationId: string): Promise<IResult<OnboardingProgressModel>> => {
    return await sendGet<OnboardingProgressModel>(`/Onboarding/application/${applicationId}/progress`);
};

export const updateOnboardingProgress = async (model: OnboardingProgressModel, baseUrl?: string): Promise<IResult<OnboardingProgressModel>> => {
    return await sendPut<OnboardingProgressModel>("/Onboarding/progress", model, baseUrl);
};

export const updateOnboardingProgressWithApiKey = async (model: OnboardingProgressModel, apiKey: string, baseUrl?: string): Promise<IResult<OnboardingProgressModel>> => {
    return await sendPutWithCustomHeaders<OnboardingProgressModel>("/Onboarding/progress", model, { 'X-Api-Key': apiKey }, baseUrl);
};
